export * from './lib/UiProductTileSecondary';
